export default __webpack_public_path__ + "static/media/tarik-data.fb197b98.webp";